import { render, staticRenderFns } from "./ChatConfigurationDialog.vue?vue&type=template&id=7643db42&lang=pug&"
import script from "./ChatConfigurationDialog.vue?vue&type=script&lang=js&"
export * from "./ChatConfigurationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatConfigurationDialog.vue"
export default component.exports